import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { pushHistoryWithAdminSection } from '../../../utils/routing';
import { USERS_RESULT_ITEMS_PER_PAGE } from '../../../utils/constants';
import { getUserRole } from '../../../utils/functions';

import TitleMinor from '../../TitleMinor/TitleMinor';
//import SearchUser from '../../SearchUser/SearchUser';
//import TableMine from '../../../containers/AdminWrapper/TableMine/TableMineWrapper';
import TableMine from '../../TableMine/TableMine';
import Input from '../../Input/Input';
import Paginator from '../../Paginator/Paginator'

import { 
  SEARCH_RESULT_INFO, 
  STATUS_ERROR_MIN_CHARS, 
  STATUS_ERROR_NOTHING_FOUND, 
  USERS_SEARCH_CONTENT_INFO 
} from './translations'

import styles from './UsersPanel.module.css'


export default class UsersPanel extends Component {
  static propTypes = {
    data: PropTypes.shape({
      isError: PropTypes.bool,
      isFetching: PropTypes.bool,
      isFetchedAll: PropTypes.bool,

      count: PropTypes.number,
      offset: PropTypes.number,
      page: PropTypes.number,
      users: PropTypes.arrayOf(PropTypes.shape({
        spaId: PropTypes.number,
        spaUsername: PropTypes.string,
        id: PropTypes.number,
        username: PropTypes.string,
        role: PropTypes.string,
        readOnly: PropTypes.bool
      })),
    }),

    isFetching: PropTypes.bool,

    fetchItemsUsersPanel: PropTypes.func,
    onGetUserData: PropTypes.func,
    onChangeUsersPage: PropTypes.func,
    onChangeUsersPrevPage: PropTypes.func,
  }

  constructor(props) {
    super(props)

    this.state = {
      searchValue: '',
      isVisibleTable: false,
      isVisibleValueMinChars: true,
      isVisibleSearchValue: false,
      isNotFound: false,
      isErrorValue: false,
      descriptionErrorMessage: null,
    }
  }

  componentDidMount() {
    if (document.location.hash && this.state.searchValue === '') {
      //this.props.history.push('', document.title, window.location.pathname);
      pushHistoryWithAdminSection(this.props.history, 'users')
    }
  }

  componentWillUnmount() {
    this.setState({
      searchValue: '',
      isVisibleTable: false,
      isVisibleValueMinChars: true,
      isVisibleSearchValue: false,
      isNotFound: false,
      isErrorValue: false,
      descriptionErrorMessage: null,
    })
  }

  componentWillReceiveProps(nextProps) { // componentWillReceiveProps(nextProps)  componentDidUpdate
    if (document.location.hash) {
      this.setState({
        searchValue: document.location.hash.slice(14),
      })
    }

    /*if (nextProps.data.users.length > 0) {
      this.setState({isVisibleTable: true})
    }*/
    //
  }

  handleSearchInputOnChange = (searchValue) => {
    const sliced = searchValue.slice(0, 50)
    let descriptionErrorMessage = null
    let isErrorValue = false;

    this.setState({
        isErrorValue: false,
    })

    if (searchValue === '' || searchValue.length === 0) {
      //this.setState({isVisibleTable: false, isVisibleSearchValue: false})
      //this.props.history.push('', document.title, window.location.pathname);
    } else if (searchValue.length < 4) {
      isErrorValue = true;
      descriptionErrorMessage = `Min length - 4 symbols.`

      this.setState({ isVisibleValueMinChars: true, descriptionErrorMessage, isErrorValue })
    } else if (searchValue.length >= 4) {
      this.setState({ isVisibleValueMinChars: false })
    }
    
    if (searchValue.length > 50) {
        isErrorValue = true;
        descriptionErrorMessage = `Max length - 50 symbols.`

        this.setState({ descriptionErrorMessage, searchValue: sliced, isErrorValue }) // searchValue: sliced.replace(/[^a-zA-Z0-9_]/g, '')
    } else {
        this.setState({ descriptionErrorMessage, searchValue, isErrorValue }) // searchValue: searchValue.replace(/[^a-zA-Z0-9_]/g, '')
    }
  }

  handleSearchBtnClicked = () => {
    if (this.state.searchValue && this.state.searchValue !== '') {
      if (this.state.searchValue.length < 4) {
        let isErrorValue = true;
        let descriptionErrorMessage = `Min length - 4 symbols.`
  
        this.setState({ isVisibleValueMinChars: true, descriptionErrorMessage, isErrorValue })
      } else {
        this.props.fetchItemsUsersPanel(this.state.searchValue)
        window.location.href = '#mt&at_search='+this.state.searchValue
        this.setState({isVisibleSearchValue: true})
      }
    }
  }

  handleBtnClearValue = () => {
    if (this.state.searchValue && this.state.searchValue !== '') {
      this.setState({
        searchValue: '', 
        isVisibleTable: false,
        isVisibleValueMinChars: true,
        isVisibleSearchValue: false,
        isNotFound: false
      })
      this.props.history.push('#mt&at_search=', document.title, window.location.pathname);
      //pushHistoryWithAdminSection(this.props.history, 'users')
    }
  }

  handleCreateUser = () => {
    //
  }

  handleBtnAllUsers = () => {
    this.props.fetchItemsUsersPanel('tm:get_all_users') // "tm%3Aget_all_users"
    window.location.href = '#mt&at_search=tm:get_all_users' // "tm%3Aget_all_users"
    this.setState({isVisibleSearchValue: true})
}

  renderMinCharsBlock = () => {
    return this.state.isVisibleValueMinChars ? (
        <div className={styles.b_search_result}>{STATUS_ERROR_MIN_CHARS}</div>
      ) : null
  }

  renderResultSearchValue = () => {
    return this.state.isVisibleSearchValue ? (
        <div className={styles.b_search_result}>
          {SEARCH_RESULT_INFO}
          <span className={styles.result}>{document.location.hash ? document.location.hash.slice(14) : null}</span>: {this.props.data.users.length ? null : <span className={styles.b_nothing_found}>{STATUS_ERROR_NOTHING_FOUND}</span>}
        </div>
      ) : null
  }

  renderPaginatorTop = () => {
      const pages = Math.ceil(this.props.data.count / USERS_RESULT_ITEMS_PER_PAGE)
      
      if (document.location.hash) {
        return pages > 1 ? (
            <React.Fragment>
              <div className={styles.l_pager}>
                <Paginator
                  pages={pages}
                  activePage={this.props.data.page}
                  onPageChange={this.props.onChangeUsersPage}
                  onPrevPageChange={this.props.onChangeUsersPrevPage}
                />
              </div>
            </React.Fragment>
        ) : null
      } else {
        return null
      }
  }

  renderPaginatorBottom = () => {
    if (this.props.data.count > 20) {
      const pages = Math.ceil(this.props.data.count / USERS_RESULT_ITEMS_PER_PAGE)
      
      if (document.location.hash) {
        return pages > 1 ? (
            <React.Fragment>
              <div className={styles.l_pager}>
                <Paginator
                  pages={pages}
                  activePage={this.props.data.page}
                  onPageChange={this.props.onChangeUsersPage}
                  onPrevPageChange={this.props.onChangeUsersPrevPage}
                />
              </div>
            </React.Fragment>
        ) : null
      } else {
        return null
      }
    }
  }

  renderButtonAllUsers = () => {
    return getUserRole() === 'admin' ? (
      <div className={styles.b_search_item}>
        <div className={classNames(styles.b_search_item, styles.b_search_item__link)}>
          <p className={styles.b_link_view} onClick={this.handleBtnAllUsers}>Все пользователи</p>
        </div>
      </div>
    ) : null
  }

  renderButtonCreateUser = () => {
    return getUserRole() === 'admin' ? (
      <div className={styles.b_search_item}>
        <div className={classNames(styles.b_search_item, styles.b_search_item__link)}>
          <p className={styles.b_link_create} onClick={this.handleCreateUser}>Создать юзера</p>
        </div>
      </div>
    ) : null
  }

  renderTable = () => {
    return document.location.hash ?
    (
      <TableMine
          data={this.props.data}
          isDisplay={true} //{this.state.isVisibleTable}   this.state.data.users.length > 0 ? true : false
          onClickBrowse={this.props.onGetUserData}
        />
    ) : (
      <TableMine
          data={this.props.data}
          isDisplay={false} //{this.state.isVisibleTable}   this.state.data.users.length > 0 ? true : false
          onClickBrowse={this.props.onGetUserData}
        />
    )
  }

  renderBody = () => {
    return (
      <div id='js-users-block'>
        <div className={classNames(styles.b_element_search, styles.b_search_sort, styles.clearfix)}>
          {/* <SearchUser value={this.props.searchTerm}
            onSearchContolClick={(value) => {
              value && this.handleSearchClicked(value) // pushHistoryWithTitle(this.props.history, value) // value && 
            }}
          /> */}
          <div className={styles.b_search}>
            <div className={styles.b_search_item} title="Введите первые символы имени пользователя">
              <Input
                key='username'
                placeholder=""
                value={this.state.searchValue}
                type=""
                isError={this.state.isErrorValue}
                onChange={this.handleSearchInputOnChange}
              />
            </div>

            <div className={styles.b_search_item}>
              <button title="Поиск" className={classNames(styles.b_btn_search, styles.b_btn_search_margin)} type="submit" onClick={this.handleSearchBtnClicked} value="" />
            </div>

            <div className={styles.b_search_item}>
              <div className={classNames(styles.b_search_item, styles.b_search_item__link)}>
                <p className={styles.b_link_fake} onClick={this.handleBtnClearValue}>Очистить</p>
              </div>
            </div>

            {this.renderButtonCreateUser()}
            {this.renderButtonAllUsers()}

          </div>
        </div>

        {this.renderMinCharsBlock()}
        
        {this.renderResultSearchValue()}

        {/* PAGINATOR TOP */}
        {this.renderPaginatorTop()}

        {this.renderTable()}

        {/* PAGINATOR BOTTOM */}
        {this.renderPaginatorBottom()}
      </div>
    )
  }

  render() {
    return (
      <React.Fragment>
        <TitleMinor>Пользователи</TitleMinor>

        <div className={styles.b_content}>
          <p>{USERS_SEARCH_CONTENT_INFO}</p>
        </div>

        {this.renderBody()}
      </React.Fragment>
    )
  }
}
